import { DmCoreError } from '@nsftx/seven-client-retail-dm-core'
import type { DMCoreErrorResponseData } from '#src/interfaces/DMCoreErrorParser'

const isDmCoreError = (error: unknown): error is DmCoreError => error instanceof DmCoreError

const parseDmCoreErrorBody = (body: unknown): string => {
  if (!body) {
    return ''
  }

  if (typeof body === 'string') {
    return body
  }

  if (typeof body === 'object') {
    const data = body as DMCoreErrorResponseData
    return data.error_description || data.detail || JSON.stringify(body)
  }

  return String(body)
}

const parseMessage = (error: unknown) => {
  if (isDmCoreError(error)) {
    return parseDmCoreErrorBody(error.body) || error.message || ''
  }

  if (error instanceof Error) {
    const message = error.message || ''
    const name = error.name || 'Error'
    const stack = error.stack ? `\nStack: ${error.stack}` : ''

    return message || name || stack
  }

  return String(error)
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const parseJsErrorCode = (error: any): string => error.code || error.name || ''

const parseCode = (error: unknown) =>
  isDmCoreError(error) ? error.status.toString() : parseJsErrorCode(error)

const parse = (error: unknown) => ({
  message: parseMessage(error),
  code: parseCode(error)
})

const parseUpstream = (error: unknown) => ({
  upstream_message: parseMessage(error),
  upstream_code: parseCode(error)
})

const errorParser = {
  parse,
  parseUpstream,
  parseMessage,
  parseCode
}

export default errorParser
